import DeletableTextField from './DeletableTextField';

export default DeletableTextField;
